import { render, staticRenderFns } from "./brand-introduction.vue?vue&type=template&id=baafb828&scoped=true&"
import script from "./brand-introduction.vue?vue&type=script&lang=js&"
export * from "./brand-introduction.vue?vue&type=script&lang=js&"
import style0 from "./brand-introduction.vue?vue&type=style&index=0&id=baafb828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baafb828",
  null
  
)

export default component.exports